/**
 * Nos ayudará a devolver el grupo de imágenes que aceptaremos en la herramienta
 */

const acceptFormatImages: Array<string> = ['image/jpg', 'image/jpeg', 'image/png'];

export default acceptFormatImages;
